module.exports = "/_next/static/images/535e2fce37bf5d51d534f2ddc908b3b0-hero-xs.jpg.webp";